import { useReward } from '@/contexts/reward-context';
import { simplifyLanguageCode } from '@/utils/site';

import { RewardModalWrapper } from '@/components/reward-modal-wrapper';
import { CloseIcon } from '@/components/svg-icons';

export const PromoteSbcModal = ({ 
	onClose 
}: { 
	onClose: () => void 
}) => {
	const { lang, labels, currencyName } = useReward();
	const shortLang = simplifyLanguageCode(lang);

	return (
		<RewardModalWrapper>
			<div 
				className="reward-modal-close reward-modal-close--sbc-flow"
				onClick={onClose}
			>
				<div className="reward-modal-close__btn">
					<CloseIcon />
				</div>
			</div>
			<div className="reward-sbc-flow">
				<div 
					className="reward-sbc-flow__container"
					style={{
						backgroundImage: `url('/events/reward/sbc-flow/${shortLang}/bg-sbc-flow-popup.png')`
					}}
				>
					<img 
						src={`/events/reward/sbc-flow/${shortLang}/sbc-flow-popup-head.png`} 
						alt="" 
					/>
					<div className="reward-sbc-flow__content">
						<div className="reward-sbc-flow__title">{labels?.lbl_RPExchange} 8.505 {currencyName}</div>
						<div className="reward-sbc-flow__subtitle">
							<span className="reward-sbc-flow__desc">{labels?.lbl_RPCumulativeTurnover?.replace('{X}', '')}</span>
							<span className="reward-sbc-flow__level">90</span>
							<span className="reward-sbc-flow__new-level">
								45<span className="reward-sbc-flow__arrow-icon"></span>
							</span>
						</div>
						<div className="shop-coin-threshold__progress">
							<div className="shop-coin-threshold__progress-text">
								0/45                      
							</div>
							<div 
								className="shop-coin-threshold__progress-bar" 
								style={{ width: '0%' }}
							>
							</div>
						</div>
					</div>
				</div>
			</div>
		</RewardModalWrapper>
	);
};